(function ($) {
    /*Used for date input*/
    $.fn.parseSplitDate = function (datePart) {

        var day = this.find('input:nth(0)').val();
        var month = this.find('input:nth(1)').val();
        var year = this.find('input:nth(2)').val();

        if (year == '' || month == '' || day == '') {
            return datePart == "Year"
                ? NaN
                : 0;
        }

        var y = parseInt(year, 10);
        var m = parseInt(month, 10);
        var d = parseInt(day, 10);

        var date = new Date(y, m - 1, d);
        var isValidDate = date.getFullYear() == y && date.getMonth() + 1 == m && date.getDate() == d;
        if (isValidDate) {
            return date;
        }

        return NaN;
    };

    /*
    * date-validity method executes when you add attribute data-val-date-validity in the date input
    * It makes sure typed date is valid eg. 30feb is not valid date.
    */
    $.validator.addMethod(
      "date-validity",
      function (value, element, params) {
          var dateValue = value,
              splittedDate = dateValue.split("/"),
              d = splittedDate[0],
                  m = splittedDate[1],
                  y = splittedDate[2];

          var date = new Date(y, m - 1, d);
          var isValidDate = date.getFullYear() == y && date.getMonth() + 1 == m && date.getDate() == d;
          return isValidDate;
      });

    $.validator.unobtrusive.adapters.add(
      "date-validity",
      ["date-validity"],
      function (options) {
          options.rules["date-validity"] = options.params;
          options.messages["date-validity"] = options.message;

          options.rules["date"] = false;
      });

    /*****************/
    /* True IsRequired */
    /*****************/
    $.validator.addMethod(
      "truerequired",
      function (value, element, params) {
          return value;
      });

    $.validator.unobtrusive.adapters.add(
      "truerequired",
      ["truerequired"],
      function (options) {
          options.rules["truerequired"] = options.params;
          options.messages["truerequired"] = options.message;
      });

    /**************/
    /* Split Date */
    /**************/
    $.validator.addMethod(
      "splitdate",
      function (value, element, params) {

          // get data-part from element
          var datePart = $(element).data("date-part");
          var parent = $(element).closest("[data-role='split-date']");

          var theDate = parent.parseSplitDate(datePart);

          return !isNaN(theDate);
      });

    $.validator.unobtrusive.adapters.add(
      "splitdate",
      ["splitdate"],
      function (options) {
          options.rules["splitdate"] = options.params;
          options.messages["splitdate"] = options.message;

          options.rules["date"] = false;
      });

    /***********/
    /* Min Age */
    /***********/
    $.validator.addMethod(
      "minage",
      function (value, element, params) {
          var parent = $(element).closest("[data-role='split-date']");
          var theDate = parent.parseSplitDate();

          if (isNaN(theDate)) {
              return false;
          }

          if (theDate == 0) {
              return true;
          }

          var today = new Date();
          var age = today.getFullYear() - theDate.getFullYear();
          var m = today.getMonth() - theDate.getMonth();

          if (m < 0 || (m === 0 && today.getDate() < theDate.getDate())) {
              age--;
          }

          return age >= parseInt(params.minage, 10);
      });

    $.validator.unobtrusive.adapters.add(
      "minage",
      ["minage"],
      function (options) {
          options.rules["minage"] = options.params;
          options.messages["minage"] = options.message;

          options.rules["date"] = false;
      });

    /***********/
    /* Min Date */
    /***********/
    $.validator.addMethod(
      "mindate",
      function (value, element, params) {
          var parent = $(element).closest("[data-role='split-date']");
          var theDate = parent.parseSplitDate();

          if (isNaN(theDate)) {
              return false;
          }

          if (theDate == 0) {
              return true;
          }

          var today = new Date();

          return (theDate.setHours(0, 0, 0, 0, 0) >= today.setHours(0, 0, 0, 0, 0));
      });

    $.validator.unobtrusive.adapters.add(
      "mindate",
      ["mindate"],
      function (options) {
          options.rules["mindate"] = options.params;
          options.messages["mindate"] = options.message;

          options.rules["date"] = false;
      });
}(jQuery));